import { render, staticRenderFns } from "./Shopping.vue?vue&type=template&id=f19e61c4&scoped=true"
import script from "./Shopping.vue?vue&type=script&lang=js"
export * from "./Shopping.vue?vue&type=script&lang=js"
import style0 from "./Shopping.vue?vue&type=style&index=0&id=f19e61c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19e61c4",
  null
  
)

export default component.exports